import { from, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { SnMessage } from '../../../models';

@Component({
  selector: 'sn-media-message',
  templateUrl: './media-message.component.html',
  styleUrls: ['./media-message.component.scss'],
})
export class SnMediaMessageComponent implements OnInit, OnDestroy {
  @Input() public message: SnMessage;

  public isImageType = false;
  public isAudio = false;
  public isVideo = false;
  public isLoading: boolean = false;

  private readonly _destroy$ = new Subject<void>();

  constructor() {}

  public ngOnInit(): void {
    this.isImageType = this.message.twilio.media.contentType.indexOf('image') !== -1;
    this.isAudio = this.message.twilio.media.contentType.indexOf('audio') !== -1;
    this.isVideo = this.message.twilio.media.contentType.indexOf('video') !== -1;
    this._getMediaSource();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public openFile(): void {
    if (!this.isAudio) {
      if (!this.isVideo) {
        window.open(this.message.mediaSource, '_blank');
      }
    }
  }

  private _getMediaSource(): void {
    this.isLoading = true;
    from(this.message.twilio.media.getContentTemporaryUrl())
      .pipe(takeUntil(this._destroy$))
      .subscribe((source: string) => {
        this.message.mediaSource = source;
      });
  }
}
